// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3UKFw","Div":"CustomFadeBox_Div__2QRsj","LargeDiv":"CustomFadeBox_LargeDiv__3kKsz"};